export default "__VITE_ASSET__09a77b56__"